import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import {
    Alignment,
    Button,
    Classes,
    H5,
    Navbar,
    NavbarDivider,
    NavbarGroup,
    NavbarHeading,
    Switch,
} from "@blueprintjs/core";
import kit from '../../images/wmgr_presentation_assets/wmgr_concept_elements/wmgr_kit.png';


class Home extends Component {
  render() {
    return (
       <div>
        <div className="intro">
        </div>

        <div className="banner_callout light">
          <div className="banner_callout_text">
          We bring together clinical experts, data-science and artificial intelligence with industry research on leading trends of health and wellness industry to provide tailored wellness and longevity services and wholistic 4D health technology solutions.
          </div>
      </div>


        <div className="features">
        <div className="container_space" >
          <div className="feature_image kit"/>
            <div className="content_text">
              <div className="content_text_title">Health Sample Kit</div>
              Receive your personalized bio kit over the mail with free shipping and send it to us for comprehensive personalized health analysis to get started and begin benefitting from our hybrid AI and health practitioner expert systems.
            </div>
        </div>
        <div className="container_space" >
          <div className="feature_image watch"/>
          <div className="content_text">
          <div className="content_text_title">Advanced Wearable Applications</div>
          We develop and provide health tracking applications to allow our AI and health experts to help monitor and coach users to improve behaviors that are in-line with reducing health risks, increasing fitness, and achieving personal goals.
          </div>
        </div>
        <div className="container_space" >
          <div className="feature_image desktop"/>
          <div className="content_text">
          <div className="content_text_title">Online Health Portal</div>
          Our web portal serves as an online space for both industry intelligence, as well as a personalized home for customer account and wellness information.  Our customers and partners enjoy access to the best insights from industry and for improving quality of life.
          </div>
        </div>

        <div className="container_space" >
        <div className="feature_image health_monitor"/>
        <div className="content_text">
        <div className="content_text_title">Connected Applications</div>
        We recognize the wellbeing is comprised of a variety of factors and aspects of your life, so we work to bring together the critical dimensions in a user friendly and simplified way to support your best quality of life and longevity.
        </div>
        </div>


        

</div>
    <div className="banner product">
    <div className="gradient">
</div>
        </div>
        <div className="banner_callout blue">
          <div className="banner_callout_text">
          At the heart of WMGR is a philosophy of science-based and data-driven intelligence to serve our customers and global health community. 
        </div>
      </div>
      <div className="features">

      <div className="container_space" >
        <div className="feature_image ipad_data"/>
        <div className="content_text">
        <div className="content_text_title">Data Analytics</div>
        We understand the power of data, and therefore work to understand our clients and global health and wellness topics from a new level synthesizing both global and personalized health data for research and customer benefit.
        </div>
      </div>

      <div className="container_space" >
      <div className="feature_image ipad_project"/>
      <div className="content_text">
      <div className="content_text_title">Portable Collaboration</div>
      Access to your information when you need it is important to us.  We develop and provide a variety of secure access to your wellness information and connect global experts through our technology ecosystem.
      </div>
    </div>

      </div>
      <div className="features">

        <div className="container_space" >
        <div className="feature_image data_application"/>
        <div className="content_text">
        <div className="content_text_title">Secure Data Access</div>
        Our data science practice brings together composite teams of clinical experts, data engineers, and software developers to analyze and develop key insights to improve diagnostics, risk identifications, and recommendation systems, leveraging the entire scope of information we have access to for the benefit of all.
        </div>
        </div>

        <div className="container_space" >
        <div className="feature_image vr_headset"/>
        <div className="content_text">
        <div className="content_text_title">Virtual Reality Environment</div>
        Access your health and wellness environment without leaving home via our VR Wellness Matrix world, where you can review your personal wellbeing as well as connect with health experts and others in your community benefitting from a variety of online features and environments.
        </div>
        </div>

      </div>
        
        <div className="container_space" >
          <div className="">
           </div>
        </div>
        <div className="banner lounge">
  
       

        </div> 
        
        <div className="banner_callout gray">
          <div className="banner_callout_text">
           Customers and Providers can interact on our platform through our 3D wellness matrix environment, reviewing account info and personal health as well as connecting with products and sevices, top doctors and AI avatars, and community.
          </div>
      
      </div>
        
   

    </div>
    );
  }
}

export default Home;